/**
 * Created by Raul on 15/05/2018.
 */

import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UsuarioService} from './service/usuario.service';
import {UsuarioModel} from './service/usuario.model';
import {LoginModel} from './service/login.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthResource} from '../../main-login.component/service/auth.resource';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service';
import {UserAuth} from '../../common.module/auth/user-auth.model';
import {ModalDirective, TabsetComponent, ToastService} from "ng-uikit-pro-standard";

@Component({
  selector: 'app-login-citizen',
  templateUrl: 'login.component.html'
})
export class LoginCitizenComponent implements OnInit {
  @ViewChild('formLogin')
  public modal: ModalDirective;
  @ViewChild('staticTabs')
  public staticTabs: TabsetComponent;
  @ViewChild('inputEmail')
  public txtEmail: ElementRef;
  @ViewChild('inputPasssword')
  public txtPassword: ElementRef;
  @ViewChild('inputEmailRecover')
  public txtEmailRecover: ElementRef;

  @Output() user = new EventEmitter<UserAuth>();

  public loginForm: FormGroup;
  public registerForm: FormGroup;
  public recoverForm: FormGroup;

  public newUser: UsuarioModel = <UsuarioModel> {};
  public login: LoginModel = <LoginModel> {};
  public recoverModel: UsuarioModel = <UsuarioModel> {};

  public banRegister = false;

  constructor(private fb: FormBuilder,
              private authResource: AuthResource,
              private usuarioService: UsuarioService,
              private toastMsg: ToastService,
              private authProv: AuthServerProvider) {
  }

  ngOnInit() {
    // Validators login
    this.loginForm = this.fb.group({
      defaultFormEmail: ['', Validators.compose([Validators.email, Validators.required])],
      defaultFormPass: ['', [Validators.required]]
    });
    // Validators register
    this.registerForm = this.fb.group({
      registerFormEmail: ['', Validators.compose([Validators.email, Validators.required])],
      registerFormPass: ['', [Validators.required]],
      registerFormPassConf: ['', [Validators.required]]
    });
    // Validators recover
    this.recoverForm = this.fb.group({
      defaultFormEmailRecover: ['', Validators.compose([Validators.email, Validators.required])]
    });
  }

  loginUser() {
    if (this.login.email != null || this.login.password  != null ) {
      this.authResource.login(this.login).then(res => {
        this.modal.hide();
        // Reditrect app
        // Save token locastorage
        this.authProv.logout();
        this.authProv.storeAuthenticationToken(res.token, true);
        this.user.emit(this.authProv.getUserDecoded());
        this.toastMsg.success('Se ha iniciado sesión.');
      }, err => {
        // Mensaje de error
        console.log(err);
        if (err && err.body)
          this.toastMsg.error(err.body.message);
      });
    } else {
      this.toastMsg.warning('usuario o contraseña incorrectos.');
    }
  }


  recoverAccount() {
    this.usuarioService.solicitudRecuperarCuenta(this.recoverModel).then(res => {
      this.toastMsg.success('Hemos enviado un correo a su bandeja de entrada.');
    }, err => {
      if (err.status == 400 && err.body)
        this.toastMsg.error(err.body.message);
      else
        this.toastMsg.error('Se ha producido un error inesperado.');
    });
  }

  showRegister() {
    this.staticTabs.setActiveTab(3);
  }

  showRecover() {
    this.staticTabs.setActiveTab(2);
  }

  showLogin() {
    this.staticTabs.setActiveTab(1);
  }

  cleanDataModel() {
    this.newUser = <UsuarioModel> {};
    this.login = <LoginModel> {};
    this.recoverModel = <UsuarioModel>{};
  }

  changeFocusEmail() {
    this.txtEmail.nativeElement.focus();
  }

  changeFocusPassword() {
    this.txtPassword.nativeElement.focus();
  }

  changeFocusEmailRecover() {
    console.log('Click etiqueta recuperar');
    this.txtEmailRecover.nativeElement.focus();
  }
}
